import _defineProperty from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { getter, forEach, split, normalizePath, join } from 'property-expr';
import { camelCase as _camelCase, snakeCase as _snakeCase } from 'tiny-case';
import toposort from 'toposort';
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val) {
  var quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"".concat(val, "\"") : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
var _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
var strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
var ValidationErrorNoStack = function ValidationErrorNoStack(errorOrErrors, value, field, type) {
  var _this = this;
  _classCallCheck(this, ValidationErrorNoStack);
  this.name = void 0;
  this.message = void 0;
  this.value = void 0;
  this.path = void 0;
  this.type = void 0;
  this.params = void 0;
  this.errors = void 0;
  this.inner = void 0;
  this[_Symbol$toStringTag] = 'Error';
  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  toArray(errorOrErrors).forEach(function (err) {
    if (ValidationError.isError(err)) {
      var _this$errors, _this$inner;
      (_this$errors = _this.errors).push.apply(_this$errors, _toConsumableArray(err.errors));
      var innerErrors = err.inner.length ? err.inner : [err];
      (_this$inner = _this.inner).push.apply(_this$inner, _toConsumableArray(innerErrors));
    } else {
      _this.errors.push(err);
    }
  });
  this.message = this.errors.length > 1 ? "".concat(this.errors.length, " errors occurred") : this.errors[0];
};
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(ValidationError, _Error);
  _createClass(ValidationError, null, [{
    key: "formatError",
    value: function formatError(message, params) {
      // Attempt to make the path more friendly for error message interpolation.
      var path = params.label || params.path || 'this';
      // Store the original path under `originalPath` so it isn't lost to custom
      // message functions; e.g., ones provided in `setLocale()` calls.
      params = Object.assign({}, params, {
        path: path,
        originalPath: params.path
      });
      if (typeof message === 'string') return message.replace(strReg, function (_, key) {
        return printValue(params[key]);
      });
      if (typeof message === 'function') return message(params);
      return message;
    }
  }, {
    key: "isError",
    value: function isError(err) {
      return err && err.name === 'ValidationError';
    }
  }]);
  function ValidationError(errorOrErrors, value, field, type, disableStack) {
    var _this2;
    _classCallCheck(this, ValidationError);
    var errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return _possibleConstructorReturn(_this2, errorNoStack);
    }
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ValidationError).call(this));
    _this2.value = void 0;
    _this2.path = void 0;
    _this2.type = void 0;
    _this2.params = void 0;
    _this2.errors = [];
    _this2.inner = [];
    _this2[_Symbol$toStringTag2] = 'Error';
    _this2.name = errorNoStack.name;
    _this2.message = errorNoStack.message;
    _this2.type = errorNoStack.type;
    _this2.value = errorNoStack.value;
    _this2.path = errorNoStack.path;
    _this2.errors = errorNoStack.errors;
    _this2.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this2), ValidationError);
    }
    return _this2;
  }
  _createClass(ValidationError, null, [{
    key: _Symbol$hasInstance,
    value: function value(inst) {
      return ValidationErrorNoStack[Symbol.hasInstance](inst) || _superPropGet(ValidationError, Symbol.hasInstance, this, 2)([inst]);
    }
  }]);
  return ValidationError;
}(_wrapNativeSuper(Error));
var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
      type = _ref.type,
      value = _ref.value,
      originalValue = _ref.originalValue;
    var castMsg = originalValue != null && originalValue !== value ? " (cast from the value `".concat(printValue(originalValue, true), "`).") : '.';
    return type !== 'mixed' ? "".concat(path, " must be a `").concat(type, "` type, ") + "but the final value was: `".concat(printValue(value, true), "`") + castMsg : "".concat(path, " must match the configured type. ") + "The validated value was: `".concat(printValue(value, true), "`") + castMsg;
  }
};
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  datetime: '${path} must be a valid ISO date-time',
  datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
var boolean = {
  isValue: '${path} field must be ${value}'
};
var object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}',
  exact: '${path} object contains unknown properties: ${properties}'
};
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
var tuple = {
  notType: function notType(params) {
    var path = params.path,
      value = params.value,
      spec = params.spec;
    var typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen) return "".concat(path, " tuple value has too few items, expected a length of ").concat(typeLen, " but got ").concat(value.length, " for value: `").concat(printValue(value, true), "`");
      if (value.length > typeLen) return "".concat(path, " tuple value has too many items, expected a length of ").concat(typeLen, " but got ").concat(value.length, " for value: `").concat(printValue(value, true), "`");
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
var locale = Object.assign(Object.create(null), {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean,
  tuple: tuple
});
var isSchema = function isSchema(obj) {
  return obj && obj.__isYupSchema__;
};
var Condition = /*#__PURE__*/function () {
  _createClass(Condition, null, [{
    key: "fromOptions",
    value: function fromOptions(refs, config) {
      if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
      var is = config.is,
        then = config.then,
        otherwise = config.otherwise;
      var check = typeof is === 'function' ? is : function () {
        for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
          values[_key] = arguments[_key];
        }
        return values.every(function (value) {
          return value === is;
        });
      };
      return new Condition(refs, function (values, schema) {
        var _branch;
        var branch = check.apply(void 0, _toConsumableArray(values)) ? then : otherwise;
        return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
      });
    }
  }]);
  function Condition(refs, builder) {
    _classCallCheck(this, Condition);
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  _createClass(Condition, [{
    key: "resolve",
    value: function resolve(base, options) {
      var values = this.refs.map(function (ref) {
        return (
          // TODO: ? operator here?
          ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context)
        );
      });
      var schema = this.fn(values, base, options);
      if (schema === undefined ||
      // @ts-ignore this can be base
      schema === base) {
        return base;
      }
      if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
      return schema.resolve(options);
    }
  }]);
  return Condition;
}();
var prefixes = {
  context: '$',
  value: '.'
};
function create$9(key, options) {
  return new Reference(key, options);
}
var Reference = /*#__PURE__*/function () {
  function Reference(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Reference);
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && getter(this.path, true);
    this.map = options.map;
  }
  _createClass(Reference, [{
    key: "getValue",
    value: function getValue(value, parent, context) {
      var result = this.isContext ? context : this.isValue ? value : parent;
      if (this.getter) result = this.getter(result || {});
      if (this.map) result = this.map(result);
      return result;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {Object=} options.context
     * @param {Object=} options.parent
     */
  }, {
    key: "cast",
    value: function cast(value, options) {
      return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
  }, {
    key: "resolve",
    value: function resolve() {
      return this;
    }
  }, {
    key: "describe",
    value: function describe() {
      return {
        type: 'ref',
        key: this.key
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Ref(".concat(this.key, ")");
    }
  }], [{
    key: "isRef",
    value: function isRef(value) {
      return value && value.__isYupRef;
    }
  }]);
  return Reference;
}(); // @ts-ignore
Reference.prototype.__isYupRef = true;
var isAbsent = function isAbsent(value) {
  return value == null;
};
function createValidation(config) {
  function validate(_ref2, panic, next) {
    var value = _ref2.value,
      _ref2$path = _ref2.path,
      path = _ref2$path === void 0 ? '' : _ref2$path,
      options = _ref2.options,
      originalValue = _ref2.originalValue,
      schema = _ref2.schema;
    var name = config.name,
      test = config.test,
      params = config.params,
      message = config.message,
      skipAbsent = config.skipAbsent;
    var parent = options.parent,
      context = options.context,
      _options$abortEarly2 = options.abortEarly,
      abortEarly = _options$abortEarly2 === void 0 ? schema.spec.abortEarly : _options$abortEarly2,
      _options$disableStack4 = options.disableStackTrace,
      disableStackTrace = _options$disableStack4 === void 0 ? schema.spec.disableStackTrace : _options$disableStack4;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextParams = Object.assign({
        value: value,
        originalValue: originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (var _i = 0, _Object$keys = Object.keys(nextParams); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        nextParams[key] = resolve(nextParams[key]);
      }
      var error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    var invalid = abortEarly ? panic : next;
    var ctx = {
      path: path,
      parent: parent,
      type: name,
      from: options.from,
      createError: createError,
      resolve: resolve,
      options: options,
      originalValue: originalValue,
      schema: schema
    };
    var handleResult = function handleResult(validOrError) {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    var handleError = function handleError(err) {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    var shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    var result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        if (options.sync) {
          throw new Error("Validation test of type: \"".concat(ctx.type, "\" returned a Promise during a synchronous validate. ") + "This test will finish after the validate call has returned");
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}
function getIn(schema, path, value) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : value;
  var parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  forEach(path, function (_part, isBracket, isArray) {
    var part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context: context,
      parent: parent,
      value: value
    });
    var isTuple = schema.type === 'tuple';
    var idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error("Yup.reach cannot implicitly index into a tuple type. the path part \"".concat(lastPartDebug, "\" must contain an index to the tuple element, e.g. \"").concat(lastPartDebug, "[0]\""));
      if (value && idx >= value.length) {
        throw new Error("Yup.reach cannot resolve an array item at index: ".concat(_part, ", in the path: ").concat(path, ". ") + "because there is no value at that index. ");
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: ".concat(path, ". ") + "(failed at: ".concat(lastPartDebug, " which is a type: \"").concat(schema.type, "\")"));
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}
function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
}
var ReferenceSet = /*#__PURE__*/function (_Set) {
  _inherits(ReferenceSet, _Set);
  function ReferenceSet() {
    _classCallCheck(this, ReferenceSet);
    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceSet).apply(this, arguments));
  }
  _createClass(ReferenceSet, [{
    key: "describe",
    value: function describe() {
      var description = [];
      var _iterator = _createForOfIteratorHelper(this.values()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          description.push(Reference.isRef(item) ? item.describe() : item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return description;
    }
  }, {
    key: "resolveAll",
    value: function resolveAll(resolve) {
      var result = [];
      var _iterator2 = _createForOfIteratorHelper(this.values()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          result.push(resolve(item));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new ReferenceSet(this.values());
    }
  }, {
    key: "merge",
    value: function merge(newItems, removeItems) {
      var next = this.clone();
      newItems.forEach(function (value) {
        return next.add(value);
      });
      removeItems.forEach(function (value) {
        return next.delete(value);
      });
      return next;
    }
  }]);
  return ReferenceSet;
}(_wrapNativeSuper(Set)); // tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function _clone(src) {
  var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  var copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (var i = 0; i < src.length; i++) copy[i] = _clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    var _iterator3 = _createForOfIteratorHelper(src.entries()),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
          k = _step3$value[0],
          v = _step3$value[1];
        copy.set(k, _clone(v, seen));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    var _iterator4 = _createForOfIteratorHelper(src),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _v = _step4.value;
        copy.add(_clone(_v, seen));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (var _i2 = 0, _Object$entries = Object.entries(src); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        _k = _Object$entries$_i[0],
        _v2 = _Object$entries$_i[1];
      copy[_k] = _clone(_v2, seen);
    }
  } else {
    throw Error("Unable to clone ".concat(src));
  }
  return copy;
}

// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
var Schema = /*#__PURE__*/function () {
  function Schema(options) {
    var _this3 = this;
    _classCallCheck(this, Schema);
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(function () {
      _this3.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(function (s) {
      s.nonNullable();
    });
  }

  // TODO: remove
  _createClass(Schema, [{
    key: "clone",
    value: function clone(spec) {
      if (this._mutate) {
        if (spec) Object.assign(this.spec, spec);
        return this;
      }

      // if the nested value is a schema we can skip cloning, since
      // they are already immutable
      var next = Object.create(Object.getPrototypeOf(this));

      // @ts-expect-error this is readonly
      next.type = this.type;
      next._typeCheck = this._typeCheck;
      next._whitelist = this._whitelist.clone();
      next._blacklist = this._blacklist.clone();
      next.internalTests = Object.assign({}, this.internalTests);
      next.exclusiveTests = Object.assign({}, this.exclusiveTests);

      // @ts-expect-error this is readonly
      next.deps = _toConsumableArray(this.deps);
      next.conditions = _toConsumableArray(this.conditions);
      next.tests = _toConsumableArray(this.tests);
      next.transforms = _toConsumableArray(this.transforms);
      next.spec = _clone(Object.assign({}, this.spec, spec));
      return next;
    }
  }, {
    key: "label",
    value: function label(_label) {
      var next = this.clone();
      next.spec.label = _label;
      return next;
    }
  }, {
    key: "meta",
    value: function meta() {
      if (arguments.length === 0) return this.spec.meta;
      var next = this.clone();
      next.spec.meta = Object.assign(next.spec.meta || {}, arguments.length <= 0 ? undefined : arguments[0]);
      return next;
    }
  }, {
    key: "withMutation",
    value: function withMutation(fn) {
      var before = this._mutate;
      this._mutate = true;
      var result = fn(this);
      this._mutate = before;
      return result;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      if (!schema || schema === this) return this;
      if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: ".concat(this.type, " and ").concat(schema.type));
      var base = this;
      var combined = schema.clone();
      var mergedSpec = Object.assign({}, base.spec, combined.spec);
      combined.spec = mergedSpec;
      combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

      // manually merge the blacklist/whitelist (the other `schema` takes
      // precedence in case of conflicts)
      combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
      combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

      // start with the current tests
      combined.tests = base.tests;
      combined.exclusiveTests = base.exclusiveTests;

      // manually add the new tests to ensure
      // the deduping logic is consistent
      combined.withMutation(function (next) {
        schema.tests.forEach(function (fn) {
          next.test(fn.OPTIONS);
        });
      });
      combined.transforms = [].concat(_toConsumableArray(base.transforms), _toConsumableArray(combined.transforms));
      return combined;
    }
  }, {
    key: "isType",
    value: function isType(v) {
      if (v == null) {
        if (this.spec.nullable && v === null) return true;
        if (this.spec.optional && v === undefined) return true;
        return false;
      }
      return this._typeCheck(v);
    }
  }, {
    key: "resolve",
    value: function resolve(options) {
      var schema = this;
      if (schema.conditions.length) {
        var conditions = schema.conditions;
        schema = schema.clone();
        schema.conditions = [];
        schema = conditions.reduce(function (prevSchema, condition) {
          return condition.resolve(prevSchema, options);
        }, schema);
        schema = schema.resolve(options);
      }
      return schema;
    }
  }, {
    key: "resolveOptions",
    value: function resolveOptions(options) {
      var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
      return Object.assign({}, options, {
        from: options.from || [],
        strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
        abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
        recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
        disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
      });
    }
    /**
     * Run the configured transform pipeline over an input value.
     */
  }, {
    key: "cast",
    value: function cast(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var resolvedSchema = this.resolve(Object.assign({
        value: value
      }, options));
      var allowOptionality = options.assert === 'ignore-optionality';
      var result = resolvedSchema._cast(value, options);
      if (options.assert !== false && !resolvedSchema.isType(result)) {
        if (allowOptionality && isAbsent(result)) {
          return result;
        }
        var formattedValue = printValue(value);
        var formattedResult = printValue(result);
        throw new TypeError("The value of ".concat(options.path || 'field', " could not be cast to a value ") + "that satisfies the schema type: \"".concat(resolvedSchema.type, "\". \n\n") + "attempted value: ".concat(formattedValue, " \n") + (formattedResult !== formattedValue ? "result of cast: ".concat(formattedResult) : ''));
      }
      return result;
    }
  }, {
    key: "_cast",
    value: function _cast(rawValue, options) {
      var _this4 = this;
      var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (prevValue, fn) {
        return fn.call(_this4, prevValue, rawValue, _this4);
      }, rawValue);
      if (value === undefined) {
        value = this.getDefault(options);
      }
      return value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this5 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var panic = arguments.length > 2 ? arguments[2] : undefined;
      var next = arguments.length > 3 ? arguments[3] : undefined;
      var path = options.path,
        _options$originalValu3 = options.originalValue,
        originalValue = _options$originalValu3 === void 0 ? _value : _options$originalValu3,
        _options$strict2 = options.strict,
        strict = _options$strict2 === void 0 ? this.spec.strict : _options$strict2;
      var value = _value;
      if (!strict) {
        value = this._cast(value, Object.assign({
          assert: false
        }, options));
      }
      var initialTests = [];
      for (var _i3 = 0, _Object$values = Object.values(this.internalTests); _i3 < _Object$values.length; _i3++) {
        var test = _Object$values[_i3];
        if (test) initialTests.push(test);
      }
      this.runTests({
        path: path,
        value: value,
        originalValue: originalValue,
        options: options,
        tests: initialTests
      }, panic, function (initialErrors) {
        // even if we aren't ending early we can't proceed further if the types aren't correct
        if (initialErrors.length) {
          return next(initialErrors, value);
        }
        _this5.runTests({
          path: path,
          value: value,
          originalValue: originalValue,
          options: options,
          tests: _this5.tests
        }, panic, next);
      });
    }
    /**
     * Executes a set of validations, either schema, produced Tests or a nested
     * schema validate result.
     */
  }, {
    key: "runTests",
    value: function runTests(runOptions, panic, next) {
      var fired = false;
      var tests = runOptions.tests,
        value = runOptions.value,
        originalValue = runOptions.originalValue,
        path = runOptions.path,
        options = runOptions.options;
      var panicOnce = function panicOnce(arg) {
        if (fired) return;
        fired = true;
        panic(arg, value);
      };
      var nextOnce = function nextOnce(arg) {
        if (fired) return;
        fired = true;
        next(arg, value);
      };
      var count = tests.length;
      var nestedErrors = [];
      if (!count) return nextOnce([]);
      var args = {
        value: value,
        originalValue: originalValue,
        path: path,
        options: options,
        schema: this
      };
      for (var i = 0; i < tests.length; i++) {
        var test = tests[i];
        test(args, panicOnce, function finishTestRun(err) {
          if (err) {
            Array.isArray(err) ? nestedErrors.push.apply(nestedErrors, _toConsumableArray(err)) : nestedErrors.push(err);
          }
          if (--count <= 0) {
            nextOnce(nestedErrors);
          }
        });
      }
    }
  }, {
    key: "asNestedTest",
    value: function asNestedTest(_ref3) {
      var _this6 = this;
      var key = _ref3.key,
        index = _ref3.index,
        parent = _ref3.parent,
        parentPath = _ref3.parentPath,
        originalParent = _ref3.originalParent,
        options = _ref3.options;
      var k = key != null ? key : index;
      if (k == null) {
        throw TypeError('Must include `key` or `index` for nested validations');
      }
      var isIndex = typeof k === 'number';
      var value = parent[k];
      var testOptions = Object.assign({}, options, _defineProperty(_defineProperty({
        // Nested validations fields are always strict:
        //    1. parent isn't strict so the casting will also have cast inner values
        //    2. parent is strict in which case the nested values weren't cast either
        strict: true,
        parent: parent,
        value: value,
        originalValue: originalParent[k],
        // FIXME: tests depend on `index` being passed around deeply,
        //   we should not let the options.key/index bleed through
        key: undefined
      }, isIndex ? 'index' : 'key', k), "path", isIndex || k.includes('.') ? "".concat(parentPath || '', "[").concat(isIndex ? k : "\"".concat(k, "\""), "]") : (parentPath ? "".concat(parentPath, ".") : '') + key));
      return function (_, panic, next) {
        return _this6.resolve(testOptions)._validate(value, testOptions, panic, next);
      };
    }
  }, {
    key: "validate",
    value: function validate(value, options) {
      var _options$disableStack2;
      var schema = this.resolve(Object.assign({}, options, {
        value: value
      }));
      var disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
      return new Promise(function (resolve, reject) {
        return schema._validate(value, options, function (error, parsed) {
          if (ValidationError.isError(error)) error.value = parsed;
          reject(error);
        }, function (errors, validated) {
          if (errors.length) reject(new ValidationError(errors, validated, undefined, undefined, disableStackTrace));else resolve(validated);
        });
      });
    }
  }, {
    key: "validateSync",
    value: function validateSync(value, options) {
      var _options$disableStack3;
      var schema = this.resolve(Object.assign({}, options, {
        value: value
      }));
      var result;
      var disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
      schema._validate(value, Object.assign({}, options, {
        sync: true
      }), function (error, parsed) {
        if (ValidationError.isError(error)) error.value = parsed;
        throw error;
      }, function (errors, validated) {
        if (errors.length) throw new ValidationError(errors, value, undefined, undefined, disableStackTrace);
        result = validated;
      });
      return result;
    }
  }, {
    key: "isValid",
    value: function isValid(value, options) {
      return this.validate(value, options).then(function () {
        return true;
      }, function (err) {
        if (ValidationError.isError(err)) return false;
        throw err;
      });
    }
  }, {
    key: "isValidSync",
    value: function isValidSync(value, options) {
      try {
        this.validateSync(value, options);
        return true;
      } catch (err) {
        if (ValidationError.isError(err)) return false;
        throw err;
      }
    }
  }, {
    key: "_getDefault",
    value: function _getDefault(options) {
      var defaultValue = this.spec.default;
      if (defaultValue == null) {
        return defaultValue;
      }
      return typeof defaultValue === 'function' ? defaultValue.call(this, options) : _clone(defaultValue);
    }
  }, {
    key: "getDefault",
    value: function getDefault(options
    // If schema is defaulted we know it's at least not undefined
    ) {
      var schema = this.resolve(options || {});
      return schema._getDefault(options);
    }
  }, {
    key: "default",
    value: function _default(def) {
      if (arguments.length === 0) {
        return this._getDefault();
      }
      var next = this.clone({
        default: def
      });
      return next;
    }
  }, {
    key: "strict",
    value: function strict() {
      var isStrict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return this.clone({
        strict: isStrict
      });
    }
  }, {
    key: "nullability",
    value: function nullability(nullable, message) {
      var next = this.clone({
        nullable: nullable
      });
      next.internalTests.nullable = createValidation({
        message: message,
        name: 'nullable',
        test: function test(value) {
          return value === null ? this.schema.spec.nullable : true;
        }
      });
      return next;
    }
  }, {
    key: "optionality",
    value: function optionality(optional, message) {
      var next = this.clone({
        optional: optional
      });
      next.internalTests.optionality = createValidation({
        message: message,
        name: 'optionality',
        test: function test(value) {
          return value === undefined ? this.schema.spec.optional : true;
        }
      });
      return next;
    }
  }, {
    key: "optional",
    value: function optional() {
      return this.optionality(true);
    }
  }, {
    key: "defined",
    value: function defined() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.defined;
      return this.optionality(false, message);
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return this.nullability(true);
    }
  }, {
    key: "nonNullable",
    value: function nonNullable() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.notNull;
      return this.nullability(false, message);
    }
  }, {
    key: "required",
    value: function required() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.required;
      return this.clone().withMutation(function (next) {
        return next.nonNullable(message).defined(message);
      });
    }
  }, {
    key: "notRequired",
    value: function notRequired() {
      return this.clone().withMutation(function (next) {
        return next.nullable().optional();
      });
    }
  }, {
    key: "transform",
    value: function transform(fn) {
      var next = this.clone();
      next.transforms.push(fn);
      return next;
    }
    /**
     * Adds a test function to the schema's queue of tests.
     * tests can be exclusive or non-exclusive.
     *
     * - exclusive tests, will replace any existing tests of the same name.
     * - non-exclusive: can be stacked
     *
     * If a non-exclusive test is added to a schema with an exclusive test of the same name
     * the exclusive test is removed and further tests of the same name will be stacked.
     *
     * If an exclusive test is added to a schema with non-exclusive tests of the same name
     * the previous tests are removed and further tests of the same name will replace each other.
     */
  }, {
    key: "test",
    value: function test() {
      var opts;
      if (arguments.length === 1) {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
          opts = {
            test: arguments.length <= 0 ? undefined : arguments[0]
          };
        } else {
          opts = arguments.length <= 0 ? undefined : arguments[0];
        }
      } else if (arguments.length === 2) {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          test: arguments.length <= 1 ? undefined : arguments[1]
        };
      } else {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          message: arguments.length <= 1 ? undefined : arguments[1],
          test: arguments.length <= 2 ? undefined : arguments[2]
        };
      }
      if (opts.message === undefined) opts.message = mixed.default;
      if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
      var next = this.clone();
      var validate = createValidation(opts);
      var isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
      if (opts.exclusive) {
        if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
      }
      if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
      next.tests = next.tests.filter(function (fn) {
        if (fn.OPTIONS.name === opts.name) {
          if (isExclusive) return false;
          if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
        }
        return true;
      });
      next.tests.push(validate);
      return next;
    }
  }, {
    key: "when",
    value: function when(keys, options) {
      if (!Array.isArray(keys) && typeof keys !== 'string') {
        options = keys;
        keys = '.';
      }
      var next = this.clone();
      var deps = toArray(keys).map(function (key) {
        return new Reference(key);
      });
      deps.forEach(function (dep) {
        // @ts-ignore readonly array
        if (dep.isSibling) next.deps.push(dep.key);
      });
      next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
      return next;
    }
  }, {
    key: "typeError",
    value: function typeError(message) {
      var next = this.clone();
      next.internalTests.typeError = createValidation({
        message: message,
        name: 'typeError',
        skipAbsent: true,
        test: function test(value) {
          if (!this.schema._typeCheck(value)) return this.createError({
            params: {
              type: this.schema.type
            }
          });
          return true;
        }
      });
      return next;
    }
  }, {
    key: "oneOf",
    value: function oneOf(enums) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.oneOf;
      var next = this.clone();
      enums.forEach(function (val) {
        next._whitelist.add(val);
        next._blacklist.delete(val);
      });
      next.internalTests.whiteList = createValidation({
        message: message,
        name: 'oneOf',
        skipAbsent: true,
        test: function test(value) {
          var valids = this.schema._whitelist;
          var resolved = valids.resolveAll(this.resolve);
          return resolved.includes(value) ? true : this.createError({
            params: {
              values: Array.from(valids).join(', '),
              resolved: resolved
            }
          });
        }
      });
      return next;
    }
  }, {
    key: "notOneOf",
    value: function notOneOf(enums) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.notOneOf;
      var next = this.clone();
      enums.forEach(function (val) {
        next._blacklist.add(val);
        next._whitelist.delete(val);
      });
      next.internalTests.blacklist = createValidation({
        message: message,
        name: 'notOneOf',
        test: function test(value) {
          var invalids = this.schema._blacklist;
          var resolved = invalids.resolveAll(this.resolve);
          if (resolved.includes(value)) return this.createError({
            params: {
              values: Array.from(invalids).join(', '),
              resolved: resolved
            }
          });
          return true;
        }
      });
      return next;
    }
  }, {
    key: "strip",
    value: function strip() {
      var _strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var next = this.clone();
      next.spec.strip = _strip;
      return next;
    }
    /**
     * Return a serialized description of the schema including validations, flags, types etc.
     *
     * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
     */
  }, {
    key: "describe",
    value: function describe(options) {
      var next = (options ? this.resolve(options) : this).clone();
      var _next$spec = next.spec,
        label = _next$spec.label,
        meta = _next$spec.meta,
        optional = _next$spec.optional,
        nullable = _next$spec.nullable;
      var description = {
        meta: meta,
        label: label,
        optional: optional,
        nullable: nullable,
        default: next.getDefault(options),
        type: next.type,
        oneOf: next._whitelist.describe(),
        notOneOf: next._blacklist.describe(),
        tests: next.tests.map(function (fn) {
          return {
            name: fn.OPTIONS.name,
            params: fn.OPTIONS.params
          };
        }).filter(function (n, idx, list) {
          return list.findIndex(function (c) {
            return c.name === n.name;
          }) === idx;
        })
      };
      return description;
    }
  }, {
    key: "_type",
    get: function get() {
      return this.type;
    }
  }]);
  return Schema;
}(); // @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
var _loop = function _loop() {
  var method = _arr[_i4];
  Schema.prototype["".concat(method, "At")] = function (path, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _getIn = getIn(this, path, value, options.context),
      parent = _getIn.parent,
      parentPath = _getIn.parentPath,
      schema = _getIn.schema;
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
      parent: parent,
      path: path
    }));
  };
};
for (var _i4 = 0, _arr = ['validate', 'validateSync']; _i4 < _arr.length; _i4++) {
  _loop();
}
for (var _i5 = 0, _arr2 = ['equals', 'is']; _i5 < _arr2.length; _i5++) {
  var alias = _arr2[_i5];
  Schema.prototype[alias] = Schema.prototype.oneOf;
}
for (var _i6 = 0, _arr3 = ['not', 'nope']; _i6 < _arr3.length; _i6++) {
  var _alias = _arr3[_i6];
  Schema.prototype[_alias] = Schema.prototype.notOneOf;
}
var returnsTrue = function returnsTrue() {
  return true;
};
function create$8(spec) {
  return new MixedSchema(spec);
}
var MixedSchema = /*#__PURE__*/function (_Schema) {
  _inherits(MixedSchema, _Schema);
  function MixedSchema(spec) {
    _classCallCheck(this, MixedSchema);
    return _possibleConstructorReturn(this, _getPrototypeOf(MixedSchema).call(this, typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec)));
  }
  return MixedSchema;
}(Schema);
create$8.prototype = MixedSchema.prototype;
function create$7() {
  return new BooleanSchema();
}
var BooleanSchema = /*#__PURE__*/function (_Schema2) {
  _inherits(BooleanSchema, _Schema2);
  function BooleanSchema() {
    var _this7;
    _classCallCheck(this, BooleanSchema);
    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(BooleanSchema).call(this, {
      type: 'boolean',
      check: function check(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
      }
    }));
    _this7.withMutation(function () {
      _this7.transform(function (value, _raw, ctx) {
        if (ctx.spec.coerce && !ctx.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
    return _this7;
  }
  _createClass(BooleanSchema, [{
    key: "isTrue",
    value: function isTrue() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : boolean.isValue;
      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'true'
        },
        test: function test(value) {
          return isAbsent(value) || value === true;
        }
      });
    }
  }, {
    key: "isFalse",
    value: function isFalse() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : boolean.isValue;
      return this.test({
        message: message,
        name: 'is-value',
        exclusive: true,
        params: {
          value: 'false'
        },
        test: function test(value) {
          return isAbsent(value) || value === false;
        }
      });
    }
  }, {
    key: "default",
    value: function _default(def) {
      return _superPropGet(BooleanSchema, "default", this, 3)([def]);
    }
  }, {
    key: "defined",
    value: function defined(msg) {
      return _superPropGet(BooleanSchema, "defined", this, 3)([msg]);
    }
  }, {
    key: "optional",
    value: function optional() {
      return _superPropGet(BooleanSchema, "optional", this, 3)([]);
    }
  }, {
    key: "required",
    value: function required(msg) {
      return _superPropGet(BooleanSchema, "required", this, 3)([msg]);
    }
  }, {
    key: "notRequired",
    value: function notRequired() {
      return _superPropGet(BooleanSchema, "notRequired", this, 3)([]);
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return _superPropGet(BooleanSchema, "nullable", this, 3)([]);
    }
  }, {
    key: "nonNullable",
    value: function nonNullable(msg) {
      return _superPropGet(BooleanSchema, "nonNullable", this, 3)([msg]);
    }
  }, {
    key: "strip",
    value: function strip(v) {
      return _superPropGet(BooleanSchema, "strip", this, 3)([v]);
    }
  }]);
  return BooleanSchema;
}(Schema);
create$7.prototype = BooleanSchema.prototype;

/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

// prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var struct = parseDateStruct(date);
  if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;

  // timestamps without timezone identifiers should be considered local time
  if (struct.z === undefined && struct.plusMinus === undefined) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  var totalMinutesOffset = 0;
  if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date) {
  var _regexResult$7$length, _regexResult$;
  var regexResult = isoReg.exec(date);
  if (!regexResult) return null;

  // use of toNumber() avoids NaN timestamps caused by “undefined”
  // values being passed to Date constructor
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ?
    // allow arbitrary sub-second precision beyond milliseconds
    toNumber(regexResult[7].substring(0, 3)) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
    z: regexResult[8] || undefined,
    plusMinus: regexResult[9] || undefined,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Number(str) || defaultValue;
}

// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
var rEmail =
// eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var rUrl =
// eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

// eslint-disable-next-line
var rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
var yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
var hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
var zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
var rIsoDateTime = new RegExp("".concat(yearMonthDay, "T").concat(hourMinuteSecond, "(\\.\\d+)?").concat(zOrOffset, "$"));
var isTrimmed = function isTrimmed(value) {
  return isAbsent(value) || value === value.trim();
};
var objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
var StringSchema = /*#__PURE__*/function (_Schema3) {
  _inherits(StringSchema, _Schema3);
  function StringSchema() {
    var _this8;
    _classCallCheck(this, StringSchema);
    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(StringSchema).call(this, {
      type: 'string',
      check: function check(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
      }
    }));
    _this8.withMutation(function () {
      _this8.transform(function (value, _raw, ctx) {
        if (!ctx.spec.coerce || ctx.isType(value)) return value;

        // don't ever convert arrays
        if (Array.isArray(value)) return value;
        var strValue = value != null && value.toString ? value.toString() : value;

        // no one wants plain objects converted to [Object object]
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
    return _this8;
  }
  _createClass(StringSchema, [{
    key: "required",
    value: function required(message) {
      return _superPropGet(StringSchema, "required", this, 3)([message]).withMutation(function (schema) {
        return schema.test({
          message: message || mixed.required,
          name: 'required',
          skipAbsent: true,
          test: function test(value) {
            return !!value.length;
          }
        });
      });
    }
  }, {
    key: "notRequired",
    value: function notRequired() {
      return _superPropGet(StringSchema, "notRequired", this, 3)([]).withMutation(function (schema) {
        schema.tests = schema.tests.filter(function (t) {
          return t.OPTIONS.name !== 'required';
        });
        return schema;
      });
    }
  }, {
    key: "length",
    value: function length(_length) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        skipAbsent: true,
        test: function test(value) {
          return value.length === this.resolve(_length);
        }
      });
    }
  }, {
    key: "min",
    value: function min(_min) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        skipAbsent: true,
        test: function test(value) {
          return value.length >= this.resolve(_min);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.max;
      return this.test({
        name: 'max',
        exclusive: true,
        message: message,
        params: {
          max: _max
        },
        skipAbsent: true,
        test: function test(value) {
          return value.length <= this.resolve(_max);
        }
      });
    }
  }, {
    key: "matches",
    value: function matches(regex, options) {
      var excludeEmptyString = false;
      var message;
      var name;
      if (options) {
        if (typeof options === 'object') {
          var _options$excludeEmpty = options.excludeEmptyString;
          excludeEmptyString = _options$excludeEmpty === void 0 ? false : _options$excludeEmpty;
          message = options.message;
          name = options.name;
        } else {
          message = options;
        }
      }
      return this.test({
        name: name || 'matches',
        message: message || string.matches,
        params: {
          regex: regex
        },
        skipAbsent: true,
        test: function test(value) {
          return value === '' && excludeEmptyString || value.search(regex) !== -1;
        }
      });
    }
  }, {
    key: "email",
    value: function email() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.email;
      return this.matches(rEmail, {
        name: 'email',
        message: message,
        excludeEmptyString: true
      });
    }
  }, {
    key: "url",
    value: function url() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.url;
      return this.matches(rUrl, {
        name: 'url',
        message: message,
        excludeEmptyString: true
      });
    }
  }, {
    key: "uuid",
    value: function uuid() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uuid;
      return this.matches(rUUID, {
        name: 'uuid',
        message: message,
        excludeEmptyString: false
      });
    }
  }, {
    key: "datetime",
    value: function datetime(options) {
      var message = '';
      var allowOffset;
      var precision;
      if (options) {
        if (typeof options === 'object') {
          var _options$message = options.message;
          message = _options$message === void 0 ? '' : _options$message;
          var _options$allowOffset = options.allowOffset;
          allowOffset = _options$allowOffset === void 0 ? false : _options$allowOffset;
          var _options$precision = options.precision;
          precision = _options$precision === void 0 ? undefined : _options$precision;
        } else {
          message = options;
        }
      }
      return this.matches(rIsoDateTime, {
        name: 'datetime',
        message: message || string.datetime,
        excludeEmptyString: true
      }).test({
        name: 'datetime_offset',
        message: message || string.datetime_offset,
        params: {
          allowOffset: allowOffset
        },
        skipAbsent: true,
        test: function test(value) {
          if (!value || allowOffset) return true;
          var struct = parseDateStruct(value);
          if (!struct) return false;
          return !!struct.z;
        }
      }).test({
        name: 'datetime_precision',
        message: message || string.datetime_precision,
        params: {
          precision: precision
        },
        skipAbsent: true,
        test: function test(value) {
          if (!value || precision == undefined) return true;
          var struct = parseDateStruct(value);
          if (!struct) return false;
          return struct.precision === precision;
        }
      });
    } //-- transforms --
  }, {
    key: "ensure",
    value: function ensure() {
      return this.default('').transform(function (val) {
        return val === null ? '' : val;
      });
    }
  }, {
    key: "trim",
    value: function trim() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.trim;
      return this.transform(function (val) {
        return val != null ? val.trim() : val;
      }).test({
        message: message,
        name: 'trim',
        test: isTrimmed
      });
    }
  }, {
    key: "lowercase",
    value: function lowercase() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.lowercase;
      return this.transform(function (value) {
        return !isAbsent(value) ? value.toLowerCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        skipAbsent: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toLowerCase();
        }
      });
    }
  }, {
    key: "uppercase",
    value: function uppercase() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uppercase;
      return this.transform(function (value) {
        return !isAbsent(value) ? value.toUpperCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        skipAbsent: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toUpperCase();
        }
      });
    }
  }]);
  return StringSchema;
}(Schema);
create$6.prototype = StringSchema.prototype;

//
// String Interfaces
//

var isNaN$1 = function isNaN$1(value) {
  return value != +value;
};
function create$5() {
  return new NumberSchema();
}
var NumberSchema = /*#__PURE__*/function (_Schema4) {
  _inherits(NumberSchema, _Schema4);
  function NumberSchema() {
    var _this9;
    _classCallCheck(this, NumberSchema);
    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(NumberSchema).call(this, {
      type: 'number',
      check: function check(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !isNaN$1(value);
      }
    }));
    _this9.withMutation(function () {
      _this9.transform(function (value, _raw, ctx) {
        if (!ctx.spec.coerce) return value;
        var parsed = value;
        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN;
          // don't use parseFloat to avoid positives on alpha-numeric strings
          parsed = +parsed;
        }

        // null -> NaN isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (ctx.isType(parsed) || parsed === null) return parsed;
        return parseFloat(parsed);
      });
    });
    return _this9;
  }
  _createClass(NumberSchema, [{
    key: "min",
    value: function min(_min2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min2
        },
        skipAbsent: true,
        test: function test(value) {
          return value >= this.resolve(_min2);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max2
        },
        skipAbsent: true,
        test: function test(value) {
          return value <= this.resolve(_max2);
        }
      });
    }
  }, {
    key: "lessThan",
    value: function lessThan(less) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.lessThan;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          less: less
        },
        skipAbsent: true,
        test: function test(value) {
          return value < this.resolve(less);
        }
      });
    }
  }, {
    key: "moreThan",
    value: function moreThan(more) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.moreThan;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          more: more
        },
        skipAbsent: true,
        test: function test(value) {
          return value > this.resolve(more);
        }
      });
    }
  }, {
    key: "positive",
    value: function positive() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number.positive;
      return this.moreThan(0, msg);
    }
  }, {
    key: "negative",
    value: function negative() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number.negative;
      return this.lessThan(0, msg);
    }
  }, {
    key: "integer",
    value: function integer() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number.integer;
      return this.test({
        name: 'integer',
        message: message,
        skipAbsent: true,
        test: function test(val) {
          return Number.isInteger(val);
        }
      });
    }
  }, {
    key: "truncate",
    value: function truncate() {
      return this.transform(function (value) {
        return !isAbsent(value) ? value | 0 : value;
      });
    }
  }, {
    key: "round",
    value: function round(method) {
      var _method;
      var avail = ['ceil', 'floor', 'round', 'trunc'];
      method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';

      // this exists for symemtry with the new Math.trunc
      if (method === 'trunc') return this.truncate();
      if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
      return this.transform(function (value) {
        return !isAbsent(value) ? Math[method](value) : value;
      });
    }
  }]);
  return NumberSchema;
}(Schema);
create$5.prototype = NumberSchema.prototype;

//
// Number Interfaces
//

var invalidDate = new Date('');
var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};
function create$4() {
  return new DateSchema();
}
var DateSchema = /*#__PURE__*/function (_Schema5) {
  _inherits(DateSchema, _Schema5);
  function DateSchema() {
    var _this10;
    _classCallCheck(this, DateSchema);
    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(DateSchema).call(this, {
      type: 'date',
      check: function check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    }));
    _this10.withMutation(function () {
      _this10.transform(function (value, _raw, ctx) {
        // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
        // nullability check vs TypeErrors
        if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
    return _this10;
  }
  _createClass(DateSchema, [{
    key: "prepareParam",
    value: function prepareParam(ref, name) {
      var param;
      if (!Reference.isRef(ref)) {
        var cast = this.cast(ref);
        if (!this._typeCheck(cast)) throw new TypeError("`".concat(name, "` must be a Date or a value that can be `cast()` to a Date"));
        param = cast;
      } else {
        param = ref;
      }
      return param;
    }
  }, {
    key: "min",
    value: function min(_min3) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.min;
      var limit = this.prepareParam(_min3, 'min');
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min3
        },
        skipAbsent: true,
        test: function test(value) {
          return value >= this.resolve(limit);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max3) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.max;
      var limit = this.prepareParam(_max3, 'max');
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max3
        },
        skipAbsent: true,
        test: function test(value) {
          return value <= this.resolve(limit);
        }
      });
    }
  }]);
  return DateSchema;
}(Schema);
DateSchema.INVALID_DATE = invalidDate;
create$4.prototype = DateSchema.prototype;
create$4.INVALID_DATE = invalidDate;

// @ts-expect-error
function sortFields(fields) {
  var excludedEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var edges = [];
  var nodes = new Set();
  var excludes = new Set(excludedEdges.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      a = _ref5[0],
      b = _ref5[1];
    return "".concat(a, "-").concat(b);
  }));
  function addNode(depPath, key) {
    var node = split(depPath)[0];
    nodes.add(node);
    if (!excludes.has("".concat(key, "-").concat(node))) edges.push([key, node]);
  }
  var _loop2 = function _loop2() {
    var key = _Object$keys2[_i7];
    var value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(function (path) {
      return addNode(path, key);
    });
  };
  for (var _i7 = 0, _Object$keys2 = Object.keys(fields); _i7 < _Object$keys2.length; _i7++) {
    _loop2();
  }
  return toposort.array(Array.from(nodes), edges).reverse();
}
function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}
var parseJson = function parseJson(value, _, ctx) {
  if (typeof value !== 'string') {
    return value;
  }
  var parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return ctx.isType(parsed) ? parsed : value;
};

// @ts-ignore
function _deepPartial(schema) {
  if ('fields' in schema) {
    var partial = {};
    for (var _i8 = 0, _Object$entries2 = Object.entries(schema.fields); _i8 < _Object$entries2.length; _i8++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i8], 2),
        key = _Object$entries2$_i[0],
        fieldSchema = _Object$entries2$_i[1];
      partial[key] = _deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    var nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = _deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(_deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
var deepHas = function deepHas(obj, p) {
  var path = _toConsumableArray(normalizePath(p));
  if (path.length === 1) return path[0] in obj;
  var last = path.pop();
  var parent = getter(join(path), true)(obj);
  return !!(parent && last in parent);
};
var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}
var defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
var ObjectSchema = /*#__PURE__*/function (_Schema6) {
  _inherits(ObjectSchema, _Schema6);
  function ObjectSchema(spec) {
    var _this11;
    _classCallCheck(this, ObjectSchema);
    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(ObjectSchema).call(this, {
      type: 'object',
      check: function check(value) {
        return isObject(value) || typeof value === 'function';
      }
    }));
    _this11.fields = Object.create(null);
    _this11._sortErrors = defaultSort;
    _this11._nodes = [];
    _this11._excludedEdges = [];
    _this11.withMutation(function () {
      if (spec) {
        _this11.shape(spec);
      }
    });
    return _this11;
  }
  _createClass(ObjectSchema, [{
    key: "_cast",
    value: function _cast(_value) {
      var _this12 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$stripUnknown;
      var value = _superPropGet(ObjectSchema, "_cast", this, 3)([_value, options]);

      //should ignore nulls here
      if (value === undefined) return this.getDefault(options);
      if (!this._typeCheck(value)) return value;
      var fields = this.fields;
      var strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
      var props = [].concat(this._nodes, Object.keys(value).filter(function (v) {
        return !_this12._nodes.includes(v);
      }));
      var intermediateValue = {}; // is filled during the transform below
      var innerOptions = Object.assign({}, options, {
        parent: intermediateValue,
        __validating: options.__validating || false
      });
      var isChanged = false;
      var _iterator5 = _createForOfIteratorHelper(props),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var prop = _step5.value;
          var field = fields[prop];
          var exists = prop in value;
          if (field) {
            var fieldValue = void 0;
            var inputValue = value[prop];

            // safe to mutate since this is fired in sequence
            innerOptions.path = (options.path ? "".concat(options.path, ".") : '') + prop;
            field = field.resolve({
              value: inputValue,
              context: options.context,
              parent: intermediateValue
            });
            var fieldSpec = field instanceof Schema ? field.spec : undefined;
            var strict = fieldSpec == null ? void 0 : fieldSpec.strict;
            if (fieldSpec != null && fieldSpec.strip) {
              isChanged = isChanged || prop in value;
              continue;
            }
            fieldValue = !options.__validating || !strict ?
            // TODO: use _cast, this is double resolving
            field.cast(value[prop], innerOptions) : value[prop];
            if (fieldValue !== undefined) {
              intermediateValue[prop] = fieldValue;
            }
          } else if (exists && !strip) {
            intermediateValue[prop] = value[prop];
          }
          if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
            isChanged = true;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      return isChanged ? intermediateValue : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this13 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var panic = arguments.length > 2 ? arguments[2] : undefined;
      var next = arguments.length > 3 ? arguments[3] : undefined;
      var _options$from = options.from,
        from = _options$from === void 0 ? [] : _options$from,
        _options$originalValu4 = options.originalValue,
        originalValue = _options$originalValu4 === void 0 ? _value : _options$originalValu4,
        _options$recursive2 = options.recursive,
        recursive = _options$recursive2 === void 0 ? this.spec.recursive : _options$recursive2;
      options.from = [{
        schema: this,
        value: originalValue
      }].concat(_toConsumableArray(from));
      // this flag is needed for handling `strict` correctly in the context of
      // validation vs just casting. e.g strict() on a field is only used when validating
      options.__validating = true;
      options.originalValue = originalValue;
      _superPropGet(ObjectSchema, "_validate", this, 3)([_value, options, panic, function (objectErrors, value) {
        if (!recursive || !isObject(value)) {
          next(objectErrors, value);
          return;
        }
        originalValue = originalValue || value;
        var tests = [];
        var _iterator6 = _createForOfIteratorHelper(_this13._nodes),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var key = _step6.value;
            var field = _this13.fields[key];
            if (!field || Reference.isRef(field)) {
              continue;
            }
            tests.push(field.asNestedTest({
              options: options,
              key: key,
              parent: value,
              parentPath: options.path,
              originalParent: originalValue
            }));
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        _this13.runTests({
          tests: tests,
          value: value,
          originalValue: originalValue,
          options: options
        }, panic, function (fieldErrors) {
          next(fieldErrors.sort(_this13._sortErrors).concat(objectErrors), value);
        });
      }]);
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _superPropGet(ObjectSchema, "clone", this, 3)([spec]);
      next.fields = Object.assign({}, this.fields);
      next._nodes = this._nodes;
      next._excludedEdges = this._excludedEdges;
      next._sortErrors = this._sortErrors;
      return next;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var _this14 = this;
      var next = _superPropGet(ObjectSchema, "concat", this, 3)([schema]);
      var nextFields = next.fields;
      for (var _i9 = 0, _Object$entries3 = Object.entries(this.fields); _i9 < _Object$entries3.length; _i9++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i9], 2),
          field = _Object$entries3$_i[0],
          schemaOrRef = _Object$entries3$_i[1];
        var target = nextFields[field];
        nextFields[field] = target === undefined ? schemaOrRef : target;
      }
      return next.withMutation(function (s) {
        return (
          // XXX: excludes here is wrong
          s.setFields(nextFields, [].concat(_toConsumableArray(_this14._excludedEdges), _toConsumableArray(schema._excludedEdges)))
        );
      });
    }
  }, {
    key: "_getDefault",
    value: function _getDefault(options) {
      var _this15 = this;
      if ('default' in this.spec) {
        return _superPropGet(ObjectSchema, "_getDefault", this, 3)([options]);
      }

      // if there is no default set invent one
      if (!this._nodes.length) {
        return undefined;
      }
      var dft = {};
      this._nodes.forEach(function (key) {
        var _innerOptions;
        var field = _this15.fields[key];
        var innerOptions = options;
        if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
          innerOptions = Object.assign({}, innerOptions, {
            parent: innerOptions.value,
            value: innerOptions.value[key]
          });
        }
        dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
      });
      return dft;
    }
  }, {
    key: "setFields",
    value: function setFields(shape, excludedEdges) {
      var next = this.clone();
      next.fields = shape;
      next._nodes = sortFields(shape, excludedEdges);
      next._sortErrors = sortByKeyOrder(Object.keys(shape));
      // XXX: this carries over edges which may not be what you want
      if (excludedEdges) next._excludedEdges = excludedEdges;
      return next;
    }
  }, {
    key: "shape",
    value: function shape(additions) {
      var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return this.clone().withMutation(function (next) {
        var edges = next._excludedEdges;
        if (excludes.length) {
          if (!Array.isArray(excludes[0])) excludes = [excludes];
          edges = [].concat(_toConsumableArray(next._excludedEdges), _toConsumableArray(excludes));
        }

        // XXX: excludes here is wrong
        return next.setFields(Object.assign(next.fields, additions), edges);
      });
    }
  }, {
    key: "partial",
    value: function partial() {
      var partial = {};
      for (var _i10 = 0, _Object$entries4 = Object.entries(this.fields); _i10 < _Object$entries4.length; _i10++) {
        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i10], 2),
          key = _Object$entries4$_i[0],
          schema = _Object$entries4$_i[1];
        partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
      }
      return this.setFields(partial);
    }
  }, {
    key: "deepPartial",
    value: function deepPartial() {
      var next = _deepPartial(this);
      return next;
    }
  }, {
    key: "pick",
    value: function pick(keys) {
      var picked = {};
      var _iterator7 = _createForOfIteratorHelper(keys),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var key = _step7.value;
          if (this.fields[key]) picked[key] = this.fields[key];
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      return this.setFields(picked, this._excludedEdges.filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          a = _ref7[0],
          b = _ref7[1];
        return keys.includes(a) && keys.includes(b);
      }));
    }
  }, {
    key: "omit",
    value: function omit(keys) {
      var remaining = [];
      for (var _i11 = 0, _Object$keys3 = Object.keys(this.fields); _i11 < _Object$keys3.length; _i11++) {
        var key = _Object$keys3[_i11];
        if (keys.includes(key)) continue;
        remaining.push(key);
      }
      return this.pick(remaining);
    }
  }, {
    key: "from",
    value: function from(_from, to, alias) {
      var fromGetter = getter(_from, true);
      return this.transform(function (obj) {
        if (!obj) return obj;
        var newObj = obj;
        if (deepHas(obj, _from)) {
          newObj = Object.assign({}, obj);
          if (!alias) delete newObj[_from];
          newObj[to] = fromGetter(obj);
        }
        return newObj;
      });
    } /** Parse an input JSON string to an object */
  }, {
    key: "json",
    value: function json() {
      return this.transform(parseJson);
    }
    /**
     * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
     */
  }, {
    key: "exact",
    value: function exact(message) {
      return this.test({
        name: 'exact',
        exclusive: true,
        message: message || object.exact,
        test: function test(value) {
          if (value == null) return true;
          var unknownKeys = unknown(this.schema, value);
          return unknownKeys.length === 0 || this.createError({
            params: {
              properties: unknownKeys.join(', ')
            }
          });
        }
      });
    }
  }, {
    key: "stripUnknown",
    value: function stripUnknown() {
      return this.clone({
        noUnknown: true
      });
    }
  }, {
    key: "noUnknown",
    value: function noUnknown() {
      var noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
      if (typeof noAllow !== 'boolean') {
        message = noAllow;
        noAllow = true;
      }
      var next = this.test({
        name: 'noUnknown',
        exclusive: true,
        message: message,
        test: function test(value) {
          if (value == null) return true;
          var unknownKeys = unknown(this.schema, value);
          return !noAllow || unknownKeys.length === 0 || this.createError({
            params: {
              unknown: unknownKeys.join(', ')
            }
          });
        }
      });
      next.spec.noUnknown = noAllow;
      return next;
    }
  }, {
    key: "unknown",
    value: function unknown() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
      return this.noUnknown(!allow, message);
    }
  }, {
    key: "transformKeys",
    value: function transformKeys(fn) {
      return this.transform(function (obj) {
        if (!obj) return obj;
        var result = {};
        for (var _i12 = 0, _Object$keys4 = Object.keys(obj); _i12 < _Object$keys4.length; _i12++) {
          var key = _Object$keys4[_i12];
          result[fn(key)] = obj[key];
        }
        return result;
      });
    }
  }, {
    key: "camelCase",
    value: function camelCase() {
      return this.transformKeys(_camelCase);
    }
  }, {
    key: "snakeCase",
    value: function snakeCase() {
      return this.transformKeys(_snakeCase);
    }
  }, {
    key: "constantCase",
    value: function constantCase() {
      return this.transformKeys(function (key) {
        return _snakeCase(key).toUpperCase();
      });
    }
  }, {
    key: "describe",
    value: function describe(options) {
      var next = (options ? this.resolve(options) : this).clone();
      var base = _superPropGet(ObjectSchema, "describe", this, 3)([options]);
      base.fields = {};
      for (var _i13 = 0, _Object$entries5 = Object.entries(next.fields); _i13 < _Object$entries5.length; _i13++) {
        var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i13], 2),
          key = _Object$entries5$_i[0],
          value = _Object$entries5$_i[1];
        var _innerOptions2;
        var innerOptions = options;
        if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
          innerOptions = Object.assign({}, innerOptions, {
            parent: innerOptions.value,
            value: innerOptions.value[key]
          });
        }
        base.fields[key] = value.describe(innerOptions);
      }
      return base;
    }
  }]);
  return ObjectSchema;
}(Schema);
create$3.prototype = ObjectSchema.prototype;
function create$2(type) {
  return new ArraySchema(type);
}
var ArraySchema = /*#__PURE__*/function (_Schema7) {
  _inherits(ArraySchema, _Schema7);
  function ArraySchema(type) {
    var _this16;
    _classCallCheck(this, ArraySchema);
    _this16 = _possibleConstructorReturn(this, _getPrototypeOf(ArraySchema).call(this, {
      type: 'array',
      spec: {
        types: type
      },
      check: function check(v) {
        return Array.isArray(v);
      }
    }));

    // `undefined` specifically means uninitialized, as opposed to "no subtype"
    _this16.innerType = void 0;
    _this16.innerType = type;
    return _this16;
  }
  _createClass(ArraySchema, [{
    key: "_cast",
    value: function _cast(_value, _opts) {
      var _this17 = this;
      var value = _superPropGet(ArraySchema, "_cast", this, 3)([_value, _opts]);

      // should ignore nulls here
      if (!this._typeCheck(value) || !this.innerType) {
        return value;
      }
      var isChanged = false;
      var castArray = value.map(function (v, idx) {
        var castElement = _this17.innerType.cast(v, Object.assign({}, _opts, {
          path: "".concat(_opts.path || '', "[").concat(idx, "]")
        }));
        if (castElement !== v) {
          isChanged = true;
        }
        return castElement;
      });
      return isChanged ? castArray : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this18 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var panic = arguments.length > 2 ? arguments[2] : undefined;
      var next = arguments.length > 3 ? arguments[3] : undefined;
      var _options$recursive;
      // let sync = options.sync;
      // let path = options.path;
      var innerType = this.innerType;
      // let endEarly = options.abortEarly ?? this.spec.abortEarly;
      var recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
      options.originalValue != null ? options.originalValue : _value;
      _superPropGet(ArraySchema, "_validate", this, 3)([_value, options, panic, function (arrayErrors, value) {
        var _options$originalValu2;
        if (!recursive || !innerType || !_this18._typeCheck(value)) {
          next(arrayErrors, value);
          return;
        }

        // #950 Ensure that sparse array empty slots are validated
        var tests = new Array(value.length);
        for (var index = 0; index < value.length; index++) {
          var _options$originalValu;
          tests[index] = innerType.asNestedTest({
            options: options,
            index: index,
            parent: value,
            parentPath: options.path,
            originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
          });
        }
        _this18.runTests({
          value: value,
          tests: tests,
          originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
          options: options
        }, panic, function (innerTypeErrors) {
          return next(innerTypeErrors.concat(arrayErrors), value);
        });
      }]);
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _superPropGet(ArraySchema, "clone", this, 3)([spec]);
      // @ts-expect-error readonly
      next.innerType = this.innerType;
      return next;
    } /** Parse an input JSON string to an object */
  }, {
    key: "json",
    value: function json() {
      return this.transform(parseJson);
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var next = _superPropGet(ArraySchema, "concat", this, 3)([schema]);

      // @ts-expect-error readonly
      next.innerType = this.innerType;
      if (schema.innerType)
        // @ts-expect-error readonly
        next.innerType = next.innerType ?
        // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
      return next;
    }
  }, {
    key: "of",
    value: function of(schema) {
      // FIXME: this should return a new instance of array without the default to be
      var next = this.clone();
      if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema));

      // @ts-expect-error readonly
      next.innerType = schema;
      next.spec = Object.assign({}, next.spec, {
        types: schema
      });
      return next;
    }
  }, {
    key: "length",
    value: function length(_length2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : array.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length2
        },
        skipAbsent: true,
        test: function test(value) {
          return value.length === this.resolve(_length2);
        }
      });
    }
  }, {
    key: "min",
    value: function min(_min4, message) {
      message = message || array.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min4
        },
        skipAbsent: true,
        // FIXME(ts): Array<typeof T>
        test: function test(value) {
          return value.length >= this.resolve(_min4);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max4, message) {
      message = message || array.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max4
        },
        skipAbsent: true,
        test: function test(value) {
          return value.length <= this.resolve(_max4);
        }
      });
    }
  }, {
    key: "ensure",
    value: function ensure() {
      var _this19 = this;
      return this.default(function () {
        return [];
      }).transform(function (val, original) {
        // We don't want to return `null` for nullable schema
        if (_this19._typeCheck(val)) return val;
        return original == null ? [] : [].concat(original);
      });
    }
  }, {
    key: "compact",
    value: function compact(rejector) {
      var reject = !rejector ? function (v) {
        return !!v;
      } : function (v, i, a) {
        return !rejector(v, i, a);
      };
      return this.transform(function (values) {
        return values != null ? values.filter(reject) : values;
      });
    }
  }, {
    key: "describe",
    value: function describe(options) {
      var next = (options ? this.resolve(options) : this).clone();
      var base = _superPropGet(ArraySchema, "describe", this, 3)([options]);
      if (next.innerType) {
        var _innerOptions;
        var innerOptions = options;
        if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
          innerOptions = Object.assign({}, innerOptions, {
            parent: innerOptions.value,
            value: innerOptions.value[0]
          });
        }
        base.innerType = next.innerType.describe(innerOptions);
      }
      return base;
    }
  }]);
  return ArraySchema;
}(Schema);
create$2.prototype = ArraySchema.prototype;

// @ts-ignore
function create$1(schemas) {
  return new TupleSchema(schemas);
}
var TupleSchema = /*#__PURE__*/function (_Schema8) {
  _inherits(TupleSchema, _Schema8);
  function TupleSchema(schemas) {
    var _this20;
    _classCallCheck(this, TupleSchema);
    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(TupleSchema).call(this, {
      type: 'tuple',
      spec: {
        types: schemas
      },
      check: function check(v) {
        var types = this.spec.types;
        return Array.isArray(v) && v.length === types.length;
      }
    }));
    _this20.withMutation(function () {
      _this20.typeError(tuple.notType);
    });
    return _this20;
  }
  _createClass(TupleSchema, [{
    key: "_cast",
    value: function _cast(inputValue, options) {
      var types = this.spec.types;
      var value = _superPropGet(TupleSchema, "_cast", this, 3)([inputValue, options]);
      if (!this._typeCheck(value)) {
        return value;
      }
      var isChanged = false;
      var castArray = types.map(function (type, idx) {
        var castElement = type.cast(value[idx], Object.assign({}, options, {
          path: "".concat(options.path || '', "[").concat(idx, "]")
        }));
        if (castElement !== value[idx]) isChanged = true;
        return castElement;
      });
      return isChanged ? castArray : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this21 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var panic = arguments.length > 2 ? arguments[2] : undefined;
      var next = arguments.length > 3 ? arguments[3] : undefined;
      var itemTypes = this.spec.types;
      _superPropGet(TupleSchema, "_validate", this, 3)([_value, options, panic, function (tupleErrors, value) {
        var _options$originalValu2;
        // intentionally not respecting recursive
        if (!_this21._typeCheck(value)) {
          next(tupleErrors, value);
          return;
        }
        var tests = [];
        var _iterator8 = _createForOfIteratorHelper(itemTypes.entries()),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _step8$value = _slicedToArray(_step8.value, 2),
              index = _step8$value[0],
              itemSchema = _step8$value[1];
            var _options$originalValu;
            tests[index] = itemSchema.asNestedTest({
              options: options,
              index: index,
              parent: value,
              parentPath: options.path,
              originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
            });
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
        _this21.runTests({
          value: value,
          tests: tests,
          originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
          options: options
        }, panic, function (innerTypeErrors) {
          return next(innerTypeErrors.concat(tupleErrors), value);
        });
      }]);
    }
  }, {
    key: "describe",
    value: function describe(options) {
      var next = (options ? this.resolve(options) : this).clone();
      var base = _superPropGet(TupleSchema, "describe", this, 3)([options]);
      base.innerType = next.spec.types.map(function (schema, index) {
        var _innerOptions;
        var innerOptions = options;
        if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
          innerOptions = Object.assign({}, innerOptions, {
            parent: innerOptions.value,
            value: innerOptions.value[index]
          });
        }
        return schema.describe(innerOptions);
      });
      return base;
    }
  }]);
  return TupleSchema;
}(Schema);
create$1.prototype = TupleSchema.prototype;
function create(builder) {
  return new Lazy(builder);
}
function catchValidationError(fn) {
  try {
    return fn();
  } catch (err) {
    if (ValidationError.isError(err)) return Promise.reject(err);
    throw err;
  }
}
var Lazy = /*#__PURE__*/function () {
  function Lazy(builder) {
    var _this22 = this;
    _classCallCheck(this, Lazy);
    this.type = 'lazy';
    this.__isYupSchema__ = true;
    this.spec = void 0;
    this._resolve = function (value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var schema = _this22.builder(value, options);
      if (!isSchema(schema)) throw new TypeError('lazy() functions must return a valid schema');
      if (_this22.spec.optional) schema = schema.optional();
      return schema.resolve(options);
    };
    this.builder = builder;
    this.spec = {
      meta: undefined,
      optional: false
    };
  }
  _createClass(Lazy, [{
    key: "clone",
    value: function clone(spec) {
      var next = new Lazy(this.builder);
      next.spec = Object.assign({}, this.spec, spec);
      return next;
    }
  }, {
    key: "optionality",
    value: function optionality(optional) {
      var next = this.clone({
        optional: optional
      });
      return next;
    }
  }, {
    key: "optional",
    value: function optional() {
      return this.optionality(true);
    }
  }, {
    key: "resolve",
    value: function resolve(options) {
      return this._resolve(options.value, options);
    }
  }, {
    key: "cast",
    value: function cast(value, options) {
      return this._resolve(value, options).cast(value, options);
    }
  }, {
    key: "asNestedTest",
    value: function asNestedTest(config) {
      var key = config.key,
        index = config.index,
        parent = config.parent,
        options = config.options;
      var value = parent[index != null ? index : key];
      return this._resolve(value, Object.assign({}, options, {
        value: value,
        parent: parent
      })).asNestedTest(config);
    }
  }, {
    key: "validate",
    value: function validate(value, options) {
      var _this23 = this;
      return catchValidationError(function () {
        return _this23._resolve(value, options).validate(value, options);
      });
    }
  }, {
    key: "validateSync",
    value: function validateSync(value, options) {
      return this._resolve(value, options).validateSync(value, options);
    }
  }, {
    key: "validateAt",
    value: function validateAt(path, value, options) {
      var _this24 = this;
      return catchValidationError(function () {
        return _this24._resolve(value, options).validateAt(path, value, options);
      });
    }
  }, {
    key: "validateSyncAt",
    value: function validateSyncAt(path, value, options) {
      return this._resolve(value, options).validateSyncAt(path, value, options);
    }
  }, {
    key: "isValid",
    value: function isValid(value, options) {
      try {
        return this._resolve(value, options).isValid(value, options);
      } catch (err) {
        if (ValidationError.isError(err)) {
          return Promise.resolve(false);
        }
        throw err;
      }
    }
  }, {
    key: "isValidSync",
    value: function isValidSync(value, options) {
      return this._resolve(value, options).isValidSync(value, options);
    }
  }, {
    key: "describe",
    value: function describe(options) {
      return options ? this.resolve(options).describe(options) : {
        type: 'lazy',
        meta: this.spec.meta,
        label: undefined
      };
    }
  }, {
    key: "meta",
    value: function meta() {
      if (arguments.length === 0) return this.spec.meta;
      var next = this.clone();
      next.spec.meta = Object.assign(next.spec.meta || {}, arguments.length <= 0 ? undefined : arguments[0]);
      return next;
    }
  }]);
  return Lazy;
}();
function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    // @ts-ignore
    Object.keys(custom[type]).forEach(function (method) {
      // @ts-ignore
      locale[type][method] = custom[type][method];
    });
  });
}
function addMethod(schemaType, name, fn) {
  if (!schemaType || !isSchema(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}
export { ArraySchema, BooleanSchema, DateSchema, Lazy as LazySchema, MixedSchema, NumberSchema, ObjectSchema, Schema, StringSchema, TupleSchema, ValidationError, addMethod, create$2 as array, create$7 as bool, create$7 as boolean, create$4 as date, locale as defaultLocale, getIn, isSchema, create as lazy, create$8 as mixed, create$5 as number, create$3 as object, printValue, reach, create$9 as ref, setLocale, create$6 as string, create$1 as tuple };